module.exports = __webpack_public_path__ + "static/media/Benifits8.7be6503e.webp";